module.exports = __webpack_public_path__ + "static/media/maanteeamet_logo.ba45a584.svg";